<template>
    <Inplace>
        <template #display>
            <span class="fas fa-search" style="vertical-align: middle"></span>
            <span style="margin-left: 0.5rem; vertical-align: middle">{{ lang.show }}</span>
        </template>
        <template #content>
            <img class="w-full" alt="Nature" :src="dataUrl" />
        </template>
    </Inplace>
</template>


<script>
import Inplace from 'primevue/inplace';


export default {
    name: "InplaceC",
    components: {
        Inplace,
    },
    props: {
        lang: {
            type: Object,
            default: () => {}
        },
        dataUrl: {
            type: String,
            default: ""
        }
    },
    setup() {
        return {};
    },
}
</script>